export { FaIcon } from '@monorepo/common';
export { FaIcon as default } from '@monorepo/common';
export {
  faChevronRight,
  faClock,
  faSearch,
  faChevronUp,
  faChevronLeft,
  faChevronDown,
  faExclamationCircle,
  faTruck,
  faSync,
  faTriangleExclamation,
  faArrowDown,
  faChevronCircleDown,
} from '@fortawesome/free-solid-svg-icons';

export { faXTwitter, faInstagram, faYoutube, faTiktok } from '@monorepo/common';
